import React, { useState, useEffect } from 'react';
import { Mail, Check } from 'lucide-react';

const SuccessPopup = ({ onClose, redirectTimeout = 3 }) => {
    const [timeLeft, setTimeLeft] = useState(redirectTimeout);

  useEffect(() => {
    // Start countdown
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = '/dashboard';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-8">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Icon Container */}
          <div className="relative">
            <div className="bg-emerald-100 rounded-full p-4">
              <Mail className="h-12 w-12 text-emerald-600" />
            </div>
            <div className="absolute -top-1 -right-1 bg-emerald-500 rounded-full p-1">
              <Check className="h-4 w-4 text-white" />
            </div>
          </div>

          {/* Text Content */}
          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-gray-900">
              Letter Scheduled Successfully!
            </h3>
            <p className="text-gray-600">
              Your letter has been scheduled for delivery
            </p>
          </div>

          {/* Progress Bar */}
          <div className="w-full space-y-2">
            <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-emerald-500 rounded-full transition-all duration-1000 ease-linear"
                style={{ width: `${(timeLeft / redirectTimeout) * 100}%` }}
              />
            </div>
            <p className="text-sm text-gray-500">
              Redirecting to dashboard in {timeLeft} seconds...
            </p>
          </div>

          {/* Manual Close Button */}
          <button
            onClick={onClose}
            className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;